export const XAI_SCHOOL_LINKS = Object.freeze({
  home: "https://www.xaischool.eu/",
  assessment: "https://www.xaischool.eu/test-ingresso?course=prompt-con-metodo",
  pricing: "https://www.xaischool.eu/piani?course=prompt-con-metodo",
  login: "https://www.xaischool.eu/login",
  organizations: "https://www.xaischool.eu/white-label",
});

export const methodStages = Object.freeze([
  {
    id: "incarico",
    number: "1",
    icon: "briefcase",
    label: "Incarico",
    title: "Inquadra il lavoro prima di aprire l’AI.",
    description: "Obiettivo, destinatario, vincoli e responsabilità diventano espliciti.",
    artifact: "Scheda incarico",
  },
  {
    id: "brief",
    number: "2",
    icon: "edit",
    label: "Brief",
    title: "Trasforma il bisogno in istruzioni verificabili.",
    description: "Contesto, materiali ammessi, formato e criteri di qualità guidano il lavoro.",
    artifact: "Brief di riferimento",
  },
  {
    id: "ai",
    number: "3",
    icon: "spark",
    label: "AI",
    title: "Collabora senza cedere la direzione.",
    description: "Chiedi alternative, fai emergere dubbi e correggi una scelta alla volta.",
    artifact: "Dossier di analisi",
  },
  {
    id: "verifica",
    number: "4",
    icon: "shield",
    label: "Verifica",
    title: "Controlla ciò che sembra convincente.",
    description: "Fonti, numeri, privacy, omissioni e limiti vengono verificati prima dell’uso.",
    artifact: "Registro verifiche",
  },
  {
    id: "consegna",
    number: "5",
    icon: "checkCircle",
    label: "Consegna",
    title: "Consegna un risultato che resta governabile.",
    description: "Artefatto, disclosure, prossima azione e responsabilità sono documentati.",
    artifact: "Pacchetto cliente",
  },
]);

export const transformationRows = Object.freeze([
  ["Chiedere una risposta", "Dirigere un incarico"],
  ["Accettare una bozza", "Verificare fonti, numeri e limiti"],
  ["Ripartire da zero", "Costruire processi riutilizzabili"],
  ["Nascondere l’AI", "Dichiararne l’uso con responsabilità"],
]);

export const courseLevels = Object.freeze([
  {
    name: "Starter",
    title: "Kit operativo personale",
    description: "Brief, prompt canvas, checklist di verifica",
    price: "99 €",
    duration: "6–8 ore",
    href: "https://www.xaischool.eu/piani?vertical=prompt-con-metodo&course=prompt-con-metodo&plan=Starter",
  },
  {
    name: "Advanced",
    title: "Sistema di lavoro",
    description: "Workflow, libreria, controllo qualità",
    price: "199 €",
    duration: "8–10 ore",
    href: "https://www.xaischool.eu/piani?vertical=prompt-con-metodo&course=prompt-con-metodo&plan=Advanced",
  },
  {
    name: "Premium",
    title: "Assistente o micro-app",
    description: "Prototipo, test, manuale e piano di adozione",
    price: "299 €",
    duration: "10–12 ore",
    href: "https://www.xaischool.eu/piani?vertical=prompt-con-metodo&course=prompt-con-metodo&plan=Premium",
  },
]);

export const caseStages = Object.freeze([
  { number: "1.", title: "Inquadra", description: "Obiettivo, destinatario, vincoli" },
  { number: "2.", title: "Collabora", description: "Contesto, strumenti, revisioni" },
  { number: "3.", title: "Verifica", description: "Fonti, numeri, privacy, limiti" },
  { number: "4.", title: "Consegna", description: "Artefatto, disclosure, prossima azione" },
]);
